var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import ReducerRegistry from '../redux/ReducerRegistry';
import { equals } from '../redux/functions';
import { SET_JWT, SET_JWT_PUBLISH } from './actionTypes';
/**
 * Reduces redux actions which affect the JSON Web Token (JWT) stored in the
 * redux store.
 *
 * @param {Object} state - The current redux state.
 * @param {Object} action - The redux action to reduce.
 * @returns {Object} The next redux state which is the result of reducing the
 * specified {@code action}.
 */
ReducerRegistry.register('features/base/jwt', (state = {}, action) => {
    switch (action.type) {
        case SET_JWT:
            {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const { type } = action, payload = __rest(action, ["type"]);
                const nextState = Object.assign({}, payload);
                return equals(state, nextState) ? state : nextState;
            }
            ;
        case SET_JWT_PUBLISH:
            return Object.assign(Object.assign({}, state), { jwt_publish: action.jwt });
    }
    return state;
});
